import { ChakraProvider, Theme as ChakraTheme } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { theme } from './theme';

const daypickerStyles = `
.rdp-root {
  --rdp-accent-color: var(--chakra-colors-brand-500);
}
.rdp {
  margin: 0;
  width: 100%;
}
.rdp-months,
.rdp-day,
.rdp-month,
.rdp-table {
  width: 100%;
  max-width: none;
}
.rdp-day.rdp-selected:not([disabled]) { 
.rdp-day_button {
  background-color: var(--chakra-colors-brand-500); 
  color: white;
}
}
`;

const reactCalendarStyles = `
.react-calendar {
  width: 350px;
  max-width: 100%;
  background: white;
  font-family: inherit;
  line-height: 1.125em;
  border-radius: 8px;
  padding: 8px;
}
.react-calendar--doubleView {
  width: 700px;
}
.react-calendar--doubleView .react-calendar__viewContainer {
  display: flex;
  margin: -0.5em;
}
.react-calendar--doubleView .react-calendar__viewContainer > * {
  width: 50%;
  margin: 0.5em;
}
.react-calendar,
.react-calendar *,
.react-calendar *:before,
.react-calendar *:after {
  box-sizing: border-box;
}
.react-calendar button {
  margin: 0;
  border: 0;
  outline: none;
}
.react-calendar button:enabled:hover {
  cursor: pointer;
}
.react-calendar__navigation {
  display: flex;
  height: 44px;
  margin-bottom: 1em;
}
.react-calendar__navigation button {
  min-width: 44px;
  background: none;
  font-size: 1em;
  font-weight: 600;
  color: var(--chakra-colors-gray-700);
}
.react-calendar__navigation button:disabled {
  background-color: #f0f0f0;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: var(--chakra-colors-gray-100);
  border-radius: 6px;
}
.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-size: 0.7em;
  font-weight: 700;
  color: var(--chakra-colors-gray-500);
}
.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}
.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
}
.react-calendar__month-view__days__day--weekend {
  color: var(--chakra-colors-red-500);
}
.react-calendar__month-view__days__day--neighboringMonth,
.react-calendar__decade-view__years__year--neighboringDecade,
.react-calendar__century-view__decades__decade--neighboringCentury {
  color: var(--chakra-colors-gray-400);
}
.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1.5em 0.5em;
}
.react-calendar__tile {
  max-width: 100%;
  padding: 8px 6px;
  background: none;
  text-align: center;
  font: inherit;
  font-size: 0.833em;
  border-radius: 6px;
}
.react-calendar__tile:disabled {
  background-color: var(--chakra-colors-gray-100);
  color: var(--chakra-colors-gray-400);
}
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: var(--chakra-colors-gray-100);
}
.react-calendar__tile--now {
  background: var(--chakra-colors-brand-50);
  color: var(--chakra-colors-brand-700);
  font-weight: 600;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: var(--chakra-colors-brand-100);
}
.react-calendar__tile--hasActive {
  background: var(--chakra-colors-brand-100);
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: var(--chakra-colors-brand-200);
}
.react-calendar__tile--active {
  background: var(--chakra-colors-brand-500);
  color: white;
  font-weight: 500;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: var(--chakra-colors-brand-600);
}
.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: var(--chakra-colors-brand-50);
}
`;

const fieldErrorAnimation = `
@keyframes fieldErrorSlideIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

const fontsStyle = `
  @font-face {
      font-family: Avenir;
      src: local("Avenir"),url("/avenir.otf") format("opentype")
    }
`;

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ChakraProvider value={theme}>
      <style>
        {daypickerStyles}
        {reactCalendarStyles}
        {fontsStyle}
        {fieldErrorAnimation}
      </style>
      <ChakraTheme appearance="light">{children}</ChakraTheme>
    </ChakraProvider>
  );
};
